export default __webpack_public_path__ + "cd0e367e8dedc09bee9b3b610c1a03c8.jpg";